import React, { useState } from 'react';
import styled from 'styled-components';
import { Upload } from 'tdesign-react';
import CropModal from './CropModal';

export default function ImageInput({ value, onChange, cropWidth, cropHeight }) {
  const [visible, setVisible] = useState(false);
  const [originImg, setOriginImg] = useState();

  const handleClose = () => {
    setVisible(false);
    setOriginImg(null);
  };

  const onSelectChange = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const base64String = fileReader.result;
      setVisible(true);
      setOriginImg(base64String);
    };
    fileReader.readAsDataURL(file);
  };

  const onConfirm = async (base64) => {
    onChange(base64);
    handleClose();
  };

  return (
    <Root>
      <Upload
        theme='image'
        accept='image/*'
        files={value ? [{ url: value }] : []}
        onChange={(arr) => onChange(arr[0]?.url)}
        onSelectChange={onSelectChange}
      />
      <CropModal
        visible={visible}
        cropWidth={cropWidth}
        cropHeight={cropHeight}
        img={originImg}
        onClose={handleClose}
        onConfirm={onConfirm}
      />
    </Root>
  );
}

const Root = styled.div``;
